// src/pages/About.jsx
import React from 'react';

const About = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">About Tantravani</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We are a team of dedicated professionals committed to creating exceptional software solutions tailored to your unique business needs.
          </p>
        </div>
        
        {/* Company Story */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-12">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">Our Story</h2>
            <p className="text-gray-600 mb-4">
              Founded in 2024, Tantravani began with a simple mission: to make custom software accessible to businesses of all sizes. Our founders recognized that many organizations struggled to find affordable, tailored software solutions that addressed their specific challenges.
            </p>
            <p className="text-gray-600 mb-4">
              What started as a solo developers has now grown into a full-service software development company with expertise in various industries, including healthcare, hospitality, finance, and retail.
            </p>
            <p className="text-gray-600">
              In the past year, we have helped multiple businesses streamline their operations, improve efficiency, and achieve their goals through custom software solutions. Our client-centered approach and commitment to excellence have made us a trusted partner in the digital transformation journey of many organizations.
            </p>
          </div>
        </div>
        
        {/* Our Mission and Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Our Mission</h2>
            <p className="text-gray-600">
              To empower businesses with innovative software solutions that drive growth, enhance efficiency, and deliver exceptional value. We strive to be a strategic partner in our clients' success by understanding their unique challenges and providing tailored solutions that address their specific needs.
            </p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Our Vision</h2>
            <p className="text-gray-600">
              To be the leading provider of custom software solutions, recognized for our technical excellence, innovative approach, and unwavering commitment to client satisfaction. We aim to create a world where businesses can leverage technology to its fullest potential, regardless of their size or industry.
            </p>
          </div>
        </div>
        
        {/* Our Values */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-12">
          <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-4">
              <div className="h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">Excellence</h3>
              <p className="text-gray-600">
                We are committed to delivering the highest quality solutions that exceed expectations and stand the test of time.
              </p>
            </div>
            <div className="text-center p-4">
              <div className="h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">Collaboration</h3>
              <p className="text-gray-600">
                We believe in the power of working together – both internally as a team and with our clients as partners.
              </p>
            </div>
            <div className="text-center p-4">
              <div className="h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">Innovation</h3>
              <p className="text-gray-600">
                We continuously explore new technologies and approaches to deliver cutting-edge solutions that give our clients a competitive edge.
              </p>
            </div>
          </div>
        </div>
        
        {/* Team Section */}
        {/* <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-bold mb-8 text-center text-gray-800">Meet Our Leadership Team</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-32 h-32 rounded-full bg-gray-300 mx-auto mb-4 overflow-hidden">
                <img src="/api/placeholder/200/200" alt="CEO" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Amit Sharma</h3>
              <p className="text-blue-600 mb-2">CEO & Founder</p>
              <p className="text-gray-600 text-sm">
                With 15+ years of experience in software development, Amit leads our team with a vision to create innovative solutions for complex business challenges.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-32 h-32 rounded-full bg-gray-300 mx-auto mb-4 overflow-hidden">
                <img src="/api/placeholder/200/200" alt="CTO" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Priya Verma</h3>
              <p className="text-blue-600 mb-2">CTO</p>
              <p className="text-gray-600 text-sm">
                Priya oversees our technical operations, bringing her expertise in emerging technologies and ensuring we deliver cutting-edge solutions.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-32 h-32 rounded-full bg-gray-300 mx-auto mb-4 overflow-hidden">
                <img src="/api/placeholder/200/200" alt="COO" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Rahul Patel</h3>
              <p className="text-blue-600 mb-2">COO</p>
              <p className="text-gray-600 text-sm">
                Rahul ensures our operations run smoothly and efficiently, focusing on delivering exceptional client service and continuous improvement.
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default About;